import { Heart, School, Book, CalendarIcon, Image, Store, Lightbulb, Database, BookOpen, BookText, Users, ClipboardList, TrendingUp, DollarSign, BarChart3, Search, Package, FileText, Shield, LucideIcon } from 'lucide-react';

export interface AppIcon {
  id: string;
  name: string;
  icon: LucideIcon;
  color: string;
}

export const appIcons: AppIcon[] = [
  {
    id: 'good-things',
    name: 'Good Thing Tracker',
    icon: Heart,
    color: 'bg-pink-500'
  },
  {
    id: 'plms',
    name: 'JLS PLMS',
    icon: School,
    color: 'bg-emerald-500'
  },
  {
    id: 'sop',
    name: 'SOP Central',
    icon: Book,
    color: 'bg-green-500'
  },
  {
    id: 'dayaway',
    name: 'DayAway Board',
    icon: CalendarIcon,
    color: 'bg-cyan-500'
  },
  {
    id: 'ideogram',
    name: 'Ideogram PromptStorm',
    icon: Image,
    color: 'bg-indigo-500'
  },
  {
    id: 'inventory',
    name: 'Listing Management System',
    icon: Store,
    color: 'bg-blue-500'
  },
  {
    id: 'idea-machine',
    name: 'The Idea Machine',
    icon: Lightbulb,
    color: 'bg-purple-500'
  },
  {
    id: 'pmt2',
    name: 'PMT2',
    icon: Database,
    color: 'bg-orange-500'
  },
  {
    id: 'ai-devquest',
    name: 'AI DevQuest',
    icon: BookOpen,
    color: 'bg-gray-700'
  },
  {
    id: 'glossary',
    name: 'Glossary',
    icon: BookText,
    color: 'bg-teal-500'
  },
  {
    id: 'employee-directory',
    name: 'Employee Directory',
    icon: Users,
    color: 'bg-blue-500'
  },
  {
    id: 'ppc-farm',
    name: 'PPC Farm Mail Tracker',
    icon: ClipboardList,
    color: 'bg-yellow-500'
  },
  {
    id: 'farming-results',
    name: 'Farming Results',
    icon: TrendingUp,
    color: 'bg-green-500'
  },
  {
    id: 'primary-ledger',
    name: 'Primary Ledger',
    icon: DollarSign,
    color: 'bg-slate-600'
  },
  {
    id: 'sales-and-profit-history',
    name: 'Sales & Profit History',
    icon: BarChart3,
    color: 'bg-violet-500'
  },
  {
    id: 'sb-search-term-report',
    name: 'SB Search Term Report',
    icon: Search,
    color: 'bg-blue-600'
  },
  {
    id: 'amazon-index-checker',
    name: 'Amazon Index Checker',
    icon: Search,
    color: 'bg-orange-600'
  },
  {
    id: 'product-manager',
    name: 'Product Manager',
    icon: Package,
    color: 'bg-red-500'
  },
  {
    id: 'days-of-cover',
    name: 'Days of Cover',
    icon: CalendarIcon,
    color: 'bg-green-600'
  },
  {
    id: 'smart-writer',
    name: 'Smart Writer',
    icon: FileText,
    color: 'bg-purple-600'
  }
];
